import { render, staticRenderFns } from "./CommissionRulesGroup.vue?vue&type=template&id=e90a1968"
import script from "./CommissionRulesGroup.vue?vue&type=script&lang=js"
export * from "./CommissionRulesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports